
















































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import version from "@/version";
//  
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class SubjectAssist extends Vue {
    @Prop({ type: Object })
    subjectVal!: Subject.Subject;

    // @Prop({ type: Array })
    // tableData?: Subject.Subject[];

    @Prop({ type: String })
    yearMonth!: string;

    @Prop({ type: String })
    firstMonth!: string;

    @Prop({ type: String })
    lastMonth!: string;

    @Prop()
    valueListProp!: any;

    assistOptions: Assist.AssistList | Object = {};
    tableData: Subject.Subject[] = [];
    valueList: any = {}; //select 的 model值

    allOption = {
        id: null,
        no: "",
        name: "全部"
    };

    async mounted() {
        await this.getAssistList();
        await this.fetchData();
        if (this.subjectVal) {
            if (this.subjectVal.dimAccountType) {
                if (this.subjectVal.dimAccountType.includes("存货")) {
                    this.subjectVal.measuringUnit = "";
                }
            }
        }
    }
    // 获取辅助核算下拉列表
    async getAssistList() {
        if (this.subjectVal) {
            let names = this.subjectVal.dimAccountTypes;
            let i = 0;
            this.valueList = {};
            do {
                await this.getAssistData(names[i]);
                if (!this.valueListProp) this.valueList[names[i]] = this.allOption;
                i++;
            } while (i < names.length);
            this.$forceUpdate();
            if (this.valueListProp) this.valueList = this.valueListProp;
        }
    }
    getAssistData(name: string) {
        return new Promise<void>(resolve => {
            Vue.axios
                .get(
                    `dim/find?accountBookId=${
                    this.$store.state.accountBook.id
                    }&dimAccountType=${name}`
                )
                .then(res => {
                    // @ts-ignore
                    this.assistOptions[name] = res.data;
                    // @ts-ignore
                    this.assistOptions[name].unshift(this.allOption);
                    resolve();
                });
        });
    }

    // 获取数据列表
    async fetchData() {
        if (this.subjectVal) {
            const res = await Vue.axios
                .post(`details/find`, {
                    accountBookId: this.$store.state.accountBook.id,
                    subjectId: this.subjectVal.id,
                    relation: this.getRelation(),
                    startPeriod: this.firstMonth,
                    endPeriod: this.lastMonth
                })
                this.tableData = res.data.subsidiarys;
        }
    }
    // 获取select 的 model值
    getRelation() {
        if (this.subjectVal) {
            let obj: any = {
                subjectId: this.subjectVal.id
            };
            Object.keys(this.valueList).forEach(attr => {
                obj[this.transRelation(attr)] = this.valueList[attr].id;
            });

            return obj;
        }
    }

    // 选择assist
    changeAssist(str: string) {
        this.$forceUpdate();
        this.fetchData();
    }

    transRelation(val: string) {
        switch (val) {
            case "项目":
                return "dimItemId";
            case "客户":
                return "dimCustomerId";
            case "部门":
                return "dimDepartmentId";
            case "员工":
                return "dimEmployeeId";
            case "存货":
                return "dimInventoryId";
            case "供应商":
                return "dimProviderId";
            case "dimItemId":
                return "项目";
            case "dimCustomerId":
                return "客户";
            case "dimDepartmentId":
                return "部门";
            case "dimEmployeeId":
                return "员工";
            case "dimInventoryId":
                return "存货";
            case "dimProviderId":
                return "供应商";
            default:
                return "dimItemId";
        }
    }

    // 打开凭证
    dialogVoucher: boolean = false;
    openVoucher(data: any) {
        if (data.voucherId != -1) {
            this.dialogVoucher = true;
            this.$nextTick(() => {
                let comVoucher: any = this.$refs.voucher;
                comVoucher.isDialog = true;
                comVoucher.isEdit = true;
                comVoucher.shouldGetInit = false;
                comVoucher.showSaveAndAdd = false;
                comVoucher.showAdd = false;
                comVoucher.getSubjectList(data.date.replace(/-/, "").substring(0, 6), () => {
                    Vue.axios
                        .post(`voucher/` + data.voucherId + `/find`, { id: 123 })
                        .then(res => {
                            comVoucher.packVoucher(res.data)
                            comVoucher.isEdit = true;
                            comVoucher.showSaveAndAdd = false;
                            comVoucher.showAdd = false;
                        });
                });
            })
        }
    }

    // 下载
    downLoad() {
        let obj = this.getRelation()
        let dimItemId = null
        let dimCustomerId = null
        let dimDepartmentId = null
        let dimEmployeeId = null
        let dimInventoryId = null
        let dimProviderId = null
        if (this.subjectVal) {
            if (obj.dimItemId) dimItemId = obj.dimItemId
            if (obj.dimCustomerId) dimCustomerId = obj.dimCustomerId
            if (obj.dimDepartmentId) dimDepartmentId = obj.dimDepartmentId
            if (obj.dimEmployeeId) dimEmployeeId = obj.dimEmployeeId
            if (obj.dimInventoryId) dimInventoryId = obj.dimInventoryId
            if (obj.dimProviderId) dimProviderId = obj.dimProviderId
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/dimsubsidiaryledger?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&dimCustomerId=${dimCustomerId}&dimDepartmentId=${dimDepartmentId}&dimEmployeeId=${dimEmployeeId}&dimInventoryId=${dimInventoryId}&dimItemId=${dimItemId}&dimProviderId=${dimProviderId}&startPeriod=${this.firstMonth}&endPeriod=${this.lastMonth}&version=${version}&token=${this.$store.state.account.token}`);
        }
    }
    // 打印
    print() {
        let obj = this.getRelation()
        let dimItemId = null
        let dimCustomerId = null
        let dimDepartmentId = null
        let dimEmployeeId = null
        let dimInventoryId = null
        let dimProviderId = null
        if (this.subjectVal) {
            if (obj.dimItemId) dimItemId = obj.dimItemId
            if (obj.dimCustomerId) dimCustomerId = obj.dimCustomerId
            if (obj.dimDepartmentId) dimDepartmentId = obj.dimDepartmentId
            if (obj.dimEmployeeId) dimEmployeeId = obj.dimEmployeeId
            if (obj.dimInventoryId) dimInventoryId = obj.dimInventoryId
            if (obj.dimProviderId) dimProviderId = obj.dimProviderId
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/pdf/dimsubsidiaryledger?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&dimCustomerId=${dimCustomerId}&dimDepartmentId=${dimDepartmentId}&dimEmployeeId=${dimEmployeeId}&dimInventoryId=${dimInventoryId}&dimItemId=${dimItemId}&dimProviderId=${dimProviderId}&startPeriod=${this.firstMonth}&endPeriod=${this.lastMonth}&version=${version}&token=${this.$store.state.account.token}`);
        }
    }
}
